// Always-fresh migration (2026-07-13): CrewVex DROPPED the offline service
// worker. It's an online-first app (all data needs the network), and the old
// Workbox precache was the root cause of a freeze/loop where "Update now" could
// strand users on the splash and reopening served a stale bundle.
//
// New installs register NO service worker — every load goes to the network, so
// users are always on the latest deploy. This module now only TEARS DOWN any
// service worker + Cache Storage left behind by an older install, so a client
// that reaches this (new) bundle is served fresh from then on. Installs still
// controlled by the OLD worker heal via the self-destruct `src/service-worker.js`
// (their worker pulls it on its next update check and removes itself).

/**
 * Remove any registered service worker and delete every Cache Storage entry.
 * BEST-EFFORT: never throws, even when the APIs are missing or reject — a failed
 * teardown must never break boot. Safe to call on every load (idempotent; a
 * no-op once the origin is already SW-less).
 */
export async function unregisterAndClear() {
  try {
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister().catch(() => {})));
    }
  } catch (_) {
    /* best-effort */
  }

  try {
    if (typeof caches !== 'undefined' && caches.keys) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k).catch(() => {})));
    }
  } catch (_) {
    /* best-effort */
  }
}

// Back-compat shims so any stray import can't break the build. CrewVex is
// service-worker-less now; registering is intentionally a no-op.
export function register() {
  /* no-op: CrewVex no longer ships a caching service worker */
}

export function unregister() {
  unregisterAndClear();
}
